import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Grid, Typography } from '@material-ui/core/'
import apiChat from '../../../../api/chat'
import MeetingContainerUser from './components/MeetingContainerUser'
import MeetingContainerAvtor from './components/MeetingContainerAvtor'
import c from 'classnames'
import './index.scss'

const RightContainer = () => {
  const { user } = useSelector(({ session }) => session)
  const { chatUser, meeting } = useSelector(({ chat }) => chat)
  const history = useHistory()

  const userName = id => {
    if (id === chatUser?.users?.[0]?.uuid) {
      return chatUser?.users?.[1]?.name
    } else if (id === chatUser?.users?.[1]?.uuid) {
      return chatUser?.users?.[0]?.name
    }
  }

  const acceptDateMeeting = type => {
    apiChat.acceptMeeting(user?.accessKey, chatUser?.meeting?.uuid, type)
  }

  return (
    <Grid className='rightContainerWrapper'>
      {chatUser?.authorUuid === user?.user?.uuid ? (
        <MeetingContainerAvtor meeting={meeting} userName={userName} />
      ) : (
        <MeetingContainerUser acceptDateMeeting={acceptDateMeeting} />
      )}
      {chatUser?.uuid && (
        <Grid className='storyContainer'>
          <Typography className='title'>Stories to discuss</Typography>
          {chatUser?.stories?.map((i, ind) => (
            <Grid className={c('storyBox', ind && `storyBox${ind}`)} onClick={() => history.push(`/story/${i?.uuid}`)}>
              <img className='imgStory' src={i?.image?.src} />
              <Typography className='titleStory'>{i?.title}</Typography>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  )
}

export default RightContainer
